import React from 'react';
import { OnboardingStepId } from '../types';
import { useOnboarding } from '../context/OnboardingContext';

import { useTranslation } from 'react-i18next';

interface StepperProps {
  currentStep: OnboardingStepId;
  onSkip?: () => void;
}

export const Stepper: React.FC<StepperProps> = ({ currentStep, onSkip }) => {
  const { t } = useTranslation('pleri/onboarding');
  const { stepOrder } = useOnboarding();
  const currentIndex = stepOrder.indexOf(currentStep);
  const totalSteps = stepOrder.length;
  const currentStepNumber = currentIndex + 1;

  return (
    <div className="relative border-b border-gray-200 bg-white px-6 py-3 dark:border-gray-700 dark:bg-gray-900">
      <div className="mx-auto flex max-w-4xl items-center justify-between">
        {/* Step indicator */}
        <div className="text-sm font-medium text-gray-600 dark:text-gray-400">
          {t('stepOf', { currentStepNumber, totalSteps })}
        </div>

        {/* Skip button - always visible, floated to the right */}
        {onSkip && (
          <button
            onClick={onSkip}
            className="rounded-lg border border-gray-300 bg-white px-4 py-1.5 text-sm font-medium text-gray-700 transition-all hover:border-gray-400 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:hover:border-gray-500 dark:hover:bg-gray-800"
            title={t('skipThisStep')}
            data-testid="skip-pleri-onboarding"
          >
            {t('skip')}
          </button>
        )}
      </div>
    </div>
  );
};
